import moment from 'moment';
import {
  CURRENCY_SYMBOLS,
  DEFAULT_PROFILE_COLOR,
  NAME_FORMAT,
  activeTranslations,
  PROFILE_COLORS,
  STATUSES_NOVA_TRACKING,
  STATUSES_UKR_TRACKING,
} from '../enum/constants';
import { AbstractControl } from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import { HttpParams } from '@angular/common/http';

export const parseJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    console.log(e);
    return null;
  }
  // jwt.decode();
};

export const parseUTC = (date: number | string | Date): any => {
  if (!date) return null;
  // return moment.utc(new Date(date)).add(new Date().getTimezoneOffset(), 'm').toISOString() // getTimezoneOffset what?
  return new Date(
    moment.utc(new Date(date)).add('minutes', moment().utcOffset()).unix() *
    1000,
  ).toISOString();
  // return moment(date).add(3, 'hours').toDate(); // NO!
};

export const isObjectEmpty = (object: any): boolean => {
  return object && Object.keys(object).length === 0;
};

export const parseCurrency = (price: any, currency?: string) => {
  if (currency) {
    if (currency === 'USD') {
      return (CURRENCY_SYMBOLS[currency] + (price || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }));
    }
    return (
      (price || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
      CURRENCY_SYMBOLS[currency]
    );
  } else return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const parseCurrencyXXX = (price: string | number, currency?: string) => {
  if (!price) return activeTranslations.free;
  if (currency) {
    if (typeof price === 'string') price = +price;
    return `${price.toLocaleString('en-US', { minimumFractionDigits: 2 })}${CURRENCY_SYMBOLS[currency]}`;
  } else
    return price.toLocaleString('en-US', { minimumFractionDigits: 2 });
};

export const isBoolean = (data: any) => typeof data === 'boolean';

export const isToday = (t: any): boolean => {
  const today = new Date();
  const date = new Date(t);
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isYesterday = (t: any): boolean => {
  const today = new Date();
  const date = new Date(t);

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
};

export const isCurrentWeek = (t: any): boolean => {
  const today = new Date();
  const inputDate = new Date(t);

  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());

  const endOfWeek = new Date(today);
  endOfWeek.setDate(today.getDate() + (6 - today.getDay()));

  return inputDate >= startOfWeek && inputDate <= endOfWeek;
};

export const scrollTo = (elementId: string): void => {
  const elem = document?.getElementById(elementId);
  if (!elem) return;
  elem.scrollIntoView({
    behavior: 'smooth',
  });
};

export const parseNovaPoshtaStatus = (
  code: string,
  ActualDeliveryDate: string,
): string => {
  const statuses: [string, string][] = [
    ['1', STATUSES_NOVA_TRACKING.PENDING],
    ['2', STATUSES_NOVA_TRACKING.DELETED],
    ['3', STATUSES_NOVA_TRACKING.NOT_FOUND],
    ['4', STATUSES_NOVA_TRACKING.PENDING],
    ['41', STATUSES_NOVA_TRACKING.PENDING],
    ['5', STATUSES_NOVA_TRACKING.PENDING],
    ['6', STATUSES_NOVA_TRACKING.PENDING],
    ['7', STATUSES_NOVA_TRACKING.ARRIVED],
    ['8', STATUSES_NOVA_TRACKING.ARRIVED],
    ['9', STATUSES_NOVA_TRACKING.COMPLETED],
    ['10', STATUSES_NOVA_TRACKING.GOTTEN],
    ['11', STATUSES_NOVA_TRACKING.COMPLETED],
    ['12', STATUSES_NOVA_TRACKING.PENDING],
    ['101', STATUSES_NOVA_TRACKING.PENDING],
    ['102', STATUSES_NOVA_TRACKING.CANCELED],
    ['103', STATUSES_NOVA_TRACKING.CANCELED],
    ['104', STATUSES_NOVA_TRACKING.PENDING],
    ['105', STATUSES_NOVA_TRACKING.CANCELED],
    ['106', STATUSES_NOVA_TRACKING.COMPLETED],
    ['111', STATUSES_NOVA_TRACKING.ERROR],
    ['112', STATUSES_NOVA_TRACKING.PENDING],
  ];
  const status = new Map<string, string>(statuses);
  const currentStatus = status.get(code);
  if (
    currentStatus === STATUSES_NOVA_TRACKING.ARRIVED &&
    isMoreThanFewDays(ActualDeliveryDate, 3)
  ) {
    return STATUSES_NOVA_TRACKING.ARRIVED_3;
  }
  return currentStatus || 'ERROR';
};

export const parseUkrPoshtaStatus = (code: string): string => {
  const statuses: [string, string][] = [
    ['10100', STATUSES_UKR_TRACKING.REGISTERED],
    ['20700', STATUSES_UKR_TRACKING.DELIVERING],
    ['20800', STATUSES_UKR_TRACKING.DELIVERING],
    ['20900', STATUSES_UKR_TRACKING.DELIVERING],
    ['21500', STATUSES_UKR_TRACKING.DELIVERING],
    ['21700', STATUSES_UKR_TRACKING.IN_DEPARTMENT],
    ['31100', STATUSES_UKR_TRACKING.DELIVERING],
    ['41000', STATUSES_UKR_TRACKING.DELIVERED],
    ['48000', STATUSES_UKR_TRACKING.DELIVERED],
    ['41010', STATUSES_UKR_TRACKING.RETURNED],
    ['31200', STATUSES_UKR_TRACKING.RETURNING],
    ['31300', STATUSES_UKR_TRACKING.FORWARDING],
    ['31400', STATUSES_UKR_TRACKING.FORWARDING],
    ['10602', STATUSES_UKR_TRACKING.CANCELLED],
    ['10603', STATUSES_UKR_TRACKING.ERROR],
    ['21400', STATUSES_UKR_TRACKING.STORAGE],
  ];
  const status = new Map<string, string>(statuses);
  const currentStatus = status.get(code);
  return currentStatus || 'ERROR';
};

export const getUkrPoshtaStatus = (code: string): string => {
  const statuses: [string, string][] = [
    [STATUSES_UKR_TRACKING.REGISTERED, 'ukr_poshta_status.registered'],
    [STATUSES_UKR_TRACKING.IN_DEPARTMENT, 'ukr_poshta_status.in_department'],
    [STATUSES_UKR_TRACKING.DELIVERING, 'ukr_poshta_status.delivering'],
    [STATUSES_UKR_TRACKING.DELIVERED, 'ukr_poshta_status.delivered'],
    [STATUSES_UKR_TRACKING.RETURNING, 'ukr_poshta_status.returning'],
    [STATUSES_UKR_TRACKING.RETURNED, 'ukr_poshta_status.returned'],
    [STATUSES_UKR_TRACKING.FORWARDING, 'ukr_poshta_status.forwarding'],
    [STATUSES_UKR_TRACKING.CANCELLED, 'ukr_poshta_status.cancelled'],
    [STATUSES_UKR_TRACKING.STORAGE, 'ukr_poshta_status.storage'],
    [STATUSES_UKR_TRACKING.ERROR, 'ukr_poshta_status.error'],
  ];
  const status = new Map<string, string>(statuses);
  const currentStatus = status.get(code);
  return currentStatus || 'ERROR';
};

export const isMoreThanFewDays = (
  targetDateStr: string,
  days: number,
): boolean => {
  if (!targetDateStr) return false;
  const targetDate = moment(targetDateStr);
  const currentDate = moment();
  return currentDate.diff(targetDate, 'days') > days;
};

export const parseNovaPoshta = (dateString: string) => {
  try {
    // Разбиваем строку на компоненты
    const dateComponents = dateString.split(/[\s-:]/);

    // Создаем объект Date
    // Обратите внимание, что месяцы в JavaScript начинаются с 0, поэтому вычитаем 1 из номера месяца
    const jsDate = new Date(
      parseInt(dateComponents[2]),
      parseInt(dateComponents[1]) - 1,
      parseInt(dateComponents[0]),
      parseInt(dateComponents[3]),
      parseInt(dateComponents[4]),
      parseInt(dateComponents[5]),
    );

    if (isNaN(jsDate.getTime())) {
      return null;
    } else {
      return jsDate;
    }
  } catch (e) {
    return null;
  }
};

export const _filter = (value: any[]) => {
  return (value || []).filter((v) => v);
};

export const trimValidator = (
  control: AbstractControl,
): Record<string, boolean> | null => {
  const valid = !(control.value || '')?.trim();
  if (valid) {
    return { incorrect: true };
  }

  return null;
};

export const differenceDate = (
  start: Date | string | number,
  end: Date | string | number,
): number => {
  const startDate =
    typeof start === 'string' || typeof start === 'number'
      ? new Date(start)
      : start;
  const endDate =
    typeof end === 'string' || typeof end === 'number' ? new Date(end) : end;
  const differenceMs = endDate.getTime() - startDate.getTime();
  return differenceMs / (1000 * 3600 * 24);
};

// CRYPTO

export const strToSign = (str: string): string => {
  if (typeof str !== 'string') throw new Error('Input must be a string');

  const hash = CryptoJS.SHA1(str);
  return CryptoJS.enc.Base64.stringify(hash);
};

export const liqPayData = (private_key: string, params: any) => {
  const encoder = new TextEncoder();
  const utf8Bytes = encoder.encode(JSON.stringify(params));
  const binaryString = String.fromCodePoint(...utf8Bytes);
  const data = btoa(binaryString);
  return {
    data: data,
    signature: strToSign(private_key + data + private_key),
  };
};

export const hex2rgb = (hex: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  // return {r, g, b}
  return { r, g, b };
};

export const isSafari = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.includes('safari') && !userAgent.includes('chrome');
};

export const getInitials = (text: string, n = 2) => {
  return text
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, n)
      .map((word) => word[0])
      .join('')
      .toUpperCase();
};

export const getColorByLetter = (input?: string) => {
  if (!input) return DEFAULT_PROFILE_COLOR;

  const letter = (input.trim().match(/[A-Za-zА-Яа-яҐЄІЇґєії]/u)?.[0] || '').toUpperCase();
  if (!letter) return DEFAULT_PROFILE_COLOR;

  const code = letter.codePointAt(0) ?? 0;
  const index = code % PROFILE_COLORS.length;

  return PROFILE_COLORS[index];
};

export const encodeBase64 = (data: string) => {
  return btoa(data);
};

export const decodeBase64 = (base64: string) => {
  return atob(base64);
};

export const createQueryParams = (params: object): HttpParams => {
  let httpParams = new HttpParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;

    if (Array.isArray(value)) {
      for (const v of value) {
        httpParams = httpParams.append(key, `${v}`);
      }
    } else {
      httpParams = httpParams.append(key, `${value}`);
    }
  }

  return httpParams;
};

export const toTitleCase = (str: string) => {
  return str.replace(
    /\w\S*/g,
    (text: string) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
  );
};

export const parsePhoneWithCode = (phone?: string) => {
  if (!phone) return phone;
  if (phone.startsWith('+')) {
    return phone;
  } else {
    return '+' + phone;
  }
};

export const buildUsersMap = (payload: any): Record<string, { id: string; name: string; avatar?: string }> => {
  const list = (() => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.data?.items)) return payload.data.items;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.users)) return payload.users;
    if (Array.isArray(payload?.data?.users)) return payload.data.users;
    return [];
  })();

  return list.reduce((acc: Record<string, { id: string; name: string; avatar?: string }>, user: any) => {
    const id = user?.id ?? user?._id ?? user?.user_id ?? user?.manager_id;
    if (!id) return acc;

    const key = String(id);
    acc[key] = {
      id: key,
      name: getUserName(user) || 'Невідомо',
      avatar: user?.avatar || user?.avatar_url || user?.photo_url,
    };
    return acc;
  }, {});
};

let nameFormat: NAME_FORMAT | null = null;

/** Called by BaseService when the company info arrives */
export const setNameFormat = (format?: NAME_FORMAT | null): void => {
  nameFormat = format === NAME_FORMAT.LAST_FIRST ? NAME_FORMAT.LAST_FIRST : NAME_FORMAT.FIRST_LAST;
};

const getNameFormat = (): NAME_FORMAT => {
  if (!nameFormat) {
    // Names can be rendered before /companies/info resolves, so fall back to the cached company
    try {
      setNameFormat(JSON.parse(localStorage.getItem('companyobj') || '{}')?.settings?.name_format);
    } catch {
      setNameFormat(null);
    }
  }
  return nameFormat!;
};

/** Joins first and last name in the order from the company `name_format` setting ('' when both are empty) */
export const formatFullName = (firstName?: string | null, lastName?: string | null): string => {
  const parts = getNameFormat() === NAME_FORMAT.LAST_FIRST ? [lastName, firstName] : [firstName, lastName];
  return parts
    .map((part) => (part ?? '').trim())
    .filter(Boolean)
    .join(' ');
};

export const getUserName = (user: any): string | undefined => {
  if (!user) return undefined;

  const name = formatFullName(user.first_name, user.last_name);
  return name || user.full_name || user.name || user.username || user.email;
};
